module.exports = __webpack_public_path__ + "static/media/arrow-right.3ce9eab1.svg";